<template>
  <div>
    <p>{{ label }} the conversation <strong>{{ details.source_name }}</strong> (<a :href="link">Link</a>)</p>
    <ul class="list-unstyled object-details">
      <li><strong>Conversation start:</strong> {{ formatDate(details.started_at) }}</li>
    </ul>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat)
export default {
  name: "StudyUserConversation",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  computed: {
    link() {
      return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/messaging/conversations`;
    }
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('MMM Do YYYY [at] h:mma');
    }
  },
}
</script>

<style scoped>

</style>